import { graphql } from 'src/graphql';

import { ParticipantSessionsPageCalendar } from './participantSessionsPageCalendar.fragment';

export const ManageBookingPageCalendar = graphql(
  `
    fragment ManageBookingPageCalendar on Booking @_unmask {
      _id
      session {
        _id
        start
        end
        status
        created
        _researcher_user_id
        ResearcherUser {
          _id
          name
        }
        askable_live_rooms {
          sid
          composition_sid
        }
        CurrentStatus(_booking_id: $booking_id) {
          ...ParticipantSessionsPageCalendar
        }
        participants(_booking_id: $booking_id, participant_status: [1, 2, 4]) {
          _id
          status
          cancel
          Submission {
            _id
            role
          }
          no_show_request
          issue_request
          rating {
            engagement
            punctuality
            overall
          }
        }
      }
    }
  `,
  [ParticipantSessionsPageCalendar],
);
